import React from "react";
import "./NewCart.Module.css";
import { Modal, CloseButton } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { useMediaQuery } from "react-responsive";
import toast from "react-hot-toast";

import { borrarCarrito } from "../../features-slice/cart/carritoSlice";
import { obtenerCostoProductos, obtenerPuntosProductos } from "../../utils/products/products";
import { getSales } from "../../utils/products/products";
import { sendNewBuy } from "../../utils/cart/cart";
import GoogleLoginCart from "../login/GoogleLoginCart";

import Pantalla1 from "./Pantalla1";
import Pantalla2 from "./Pantalla2";
import PantallaDatos from "./PantallaDatos";
import PantallaEnvios from "./PantallaEnvios";
import PantallaPagos from "./Pantalla2";

function NewCart({ handleCloseCart, showCart }) {

  const carrito = useSelector((state) => state.carrito);
  const user = useSelector((state) => state.user.userInfo);
  const dispatch = useDispatch();

  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [pantallaActiva, setPantallaActiva] = React.useState(1);
  const [metodoPago, setMetodoPago] = React.useState("TARJETA");
  const [descuentoAplicado, setDescuentoAplicado] = React.useState(null);
  const [purchaseId, setPurchaseId] = React.useState("");

  const cantidadPuntos = obtenerPuntosProductos(carrito);

    // arriba, dentro del componente
  const totalItems = React.useMemo(
    () => carrito.reduce((acc, item) => acc + (item.cantidad ?? 1), 0),
    [carrito]
  );
  

  const [sales, setSales] = React.useState([]);
  React.useEffect(() => {
    async function getOfertas() {
      setSales(await getSales());
    }
    getOfertas();
  }, [carrito]);
	 
  const { costoConDescuento, costoConDescuentoPromo, totalDescontado } = React.useMemo(() => {
  if (!descuentoAplicado) {
    const costoPromo = obtenerCostoProductos(carrito, "EFECTIVO");
    const costoTarjeta = obtenerCostoProductos(carrito, "TARJETA");
    return {
      costoConDescuento: costoTarjeta,
      costoConDescuentoPromo: costoPromo,
      totalDescontado: 0,
    };
  }

  let totalTarjeta = 0;
  let totalPromo = 0;
  let descuentoTotal = 0;
  const porcentaje = descuentoAplicado.porcentajeDescuento || 0;
  const tag = descuentoAplicado.tagAplicable?.toLowerCase();
  const es2x1 = descuentoAplicado.tipoDescuento === "2x1";

  for (const item of carrito) {
    const cantidad = item.cantidad || 1;
    const precioTarjeta = item.precioTarjeta || 0;

    // 🔹 Si precioPromo > 0, lo usamos; si no, usamos precioEfectivo
    const precioPromo = item.precioOferta > 0 ? item.precioOferta : (item.precioEfectivo || 0);

    const marcaValida =
      descuentoAplicado.marca &&
      item.marca?.toLowerCase() === descuentoAplicado.marca.toLowerCase();

    const tagsIncluye =
      item.tags?.some((t) => t.toLowerCase() === tag) ||
      item.tags2?.some((t) => t.toLowerCase() === tag);

    const aplicaDescuento =
      (!descuentoAplicado.marca && !descuentoAplicado.tagAplicable) ||
      marcaValida ||
      tagsIncluye;

    if (aplicaDescuento) {
      if (es2x1 && cantidad >= 2) {
        const pares = Math.floor(cantidad / 2);
        const impares = cantidad % 2;
        const pagados = pares + impares;

        const subtotalTarjeta = pagados * precioTarjeta;
        const subtotalPromo = pagados * precioPromo;

        const originalSubtotalTarjeta = cantidad * precioTarjeta;
        const originalSubtotalPromo = cantidad * precioPromo;

        totalTarjeta += subtotalTarjeta;
        totalPromo += subtotalPromo;

        descuentoTotal += originalSubtotalTarjeta - subtotalTarjeta;
      } else {
        const subtotalTarjeta = precioTarjeta * cantidad;
        const subtotalPromo = precioPromo * cantidad;
        const descuento = (subtotalTarjeta * porcentaje) / 100;

        totalTarjeta += subtotalTarjeta - descuento;
        totalPromo += subtotalPromo - descuento;

        descuentoTotal += descuento;
      }
    } else {
      totalTarjeta += precioTarjeta * cantidad;
      totalPromo += precioPromo * cantidad;
    }
  }

  return {
    costoConDescuento: totalTarjeta,
    costoConDescuentoPromo: totalPromo,
    totalDescontado: descuentoTotal,
  };
}, [carrito, descuentoAplicado]);
	React.useEffect(() => {
  if (descuentoAplicado) {
    localStorage.setItem("totalTarjeta", JSON.stringify(costoConDescuento));
    localStorage.setItem("totalPromo", JSON.stringify(costoConDescuentoPromo));
  }
}, [descuentoAplicado, costoConDescuento, costoConDescuentoPromo]);


  return (
    <div className="containerModalCart">
      <Modal show={showCart} onHide={handleCloseCart} size="md" className="modal-right">
        <Modal.Header className="headerNewCart">
          <Modal.Title>
            <div className="divTitulo">
              <h4
                style={{
                  color: "#23563F",
                  fontFamily: "Poppins",
                  fontSize: "18px",
                }}
              >
                {pantallaActiva === 1
                 ? `Bag de compras (${totalItems})`
                  : (pantallaActiva === 2 ||pantallaActiva === 4)
                  ? "Método de pago"
                  : "Datos de contacto"}
              </h4>
            </div>
          </Modal.Title>
          <CloseButton style={{ height: "20px" }} onClick={handleCloseCart} />
        </Modal.Header>

        <Modal.Body className="containerBodyModal">
          {pantallaActiva === 1 && (
            <Pantalla1
              close={handleCloseCart}
              setPantalla={setPantallaActiva}
              setPurchase={setPurchaseId}
              pantallaActiva={pantallaActiva}
              descuentoAplicado={descuentoAplicado}
              setDescuentoAplicado={setDescuentoAplicado}
              costoConDescuento={costoConDescuento}
              costoConDescuentoPromo={costoConDescuentoPromo}
              totalDescontado={totalDescontado}
              metodoPago={metodoPago}
              setMetodoPago={setMetodoPago}
            />
          )}

          {pantallaActiva === 2 && (
            <PantallaPagos
              close={handleCloseCart}
              idCompra={purchaseId}
              setPantalla={setPantallaActiva}
							    descuentoId={descuentoAplicado?._id}
									 costoConDescuento={costoConDescuento}
              costoConDescuentoPromo={costoConDescuentoPromo}
            />
          )}

          {pantallaActiva === 3 && (
            <PantallaDatos
              close={handleCloseCart}
              idCompra={purchaseId}
              setPantalla={setPantallaActiva}
              setPurchase={setPurchaseId}
              descuentoId={descuentoAplicado?._id}
              costoConDescuento={costoConDescuento}
              costoConDescuentoPromo={costoConDescuentoPromo}
              totalDescontado={totalDescontado}
              descuentoAplicado={descuentoAplicado}
              metodoPago={metodoPago}
            />
          )}

           {pantallaActiva === 4 && (
             <PantallaPagos
              close={handleCloseCart}
              idCompra={purchaseId}
              setPantalla={setPantallaActiva}
							    descuentoId={descuentoAplicado?._id}
									 costoConDescuento={costoConDescuento}
              costoConDescuentoPromo={costoConDescuentoPromo}
            />
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default NewCart;
